import {Pipe, PipeTransform} from '@angular/core';
import {PolicyConfigVO, PolicyPermissionVO, PolicyType} from '../../../../generate/TopLevelDomainVO';

@Pipe({
  name: 'authPolicyHelper'
})
export class AuthPolicyHelperPipe implements PipeTransform {

  transform(value: any, type: string, policyType?: PolicyType): any {
    switch (type) {
      case 'permissions':
        return this.buildPermissions(value);
      case 'policy':
        return this.getReadablePolicy(value, policyType);

    }
    return null;
  }

  private buildPermissions(value: PolicyPermissionVO[]) {
    let readablePermissions = '';
    let count = 0;
    value.forEach(permission => {
      if (permission.permission === 'Approve') {
        count++;
        readablePermissions = readablePermissions + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.getPolicyType(permission.policyType);
      }
    });

    if (count === 4) {
      return 'All';
    } else {
      return readablePermissions.trim().replace('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', '');
    }
  }

  private getPolicyType(policyType: PolicyType) {
    let type;
    switch (policyType) {
      case 'Control':
        type = 'Change of Control';
        break;
      case 'AuthPolicy':
        type = 'Authorization Policy';
        break;
      default:
        type = policyType;
    }

    return type;
  }

  private getReadablePolicy(value: PolicyConfigVO[], policyType: string) {
    if(value){
      let policyConfig = value.filter(config => config.policyType === policyType).pop();
      if (policyConfig.policyThreshold.thresholdType === 'Limit') {
        return 'Minimum (' + policyConfig.policyThreshold.limit + ') in authorizer group';
      } else {
        return policyConfig.policyThreshold.thresholdType + ' in authorizer group';
      }
    }else{
      return ''
    }

  }
}
